import React, { Component } from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import { Button, Card } from "react-bootstrap";
import Styled from 'styled-components';

const StyledPopup = Styled(Popup)`
  &-content {
    width: 50%;
    height: 60%;
    padding: 10px 5px;
    border-radius: 18px;
  }
`;


class PopupButton extends Component {
  state = {};
  render() {
    return (
      <StyledPopup
        trigger={<Button variant="primary">More info...</Button>}
        position="right center"
        modal
      >
        <span>{this.props.popupContent}</span>
      </StyledPopup>
    );
  }
}

export default PopupButton;
